import { appstoreConstants } from '../constants/appstore.constants';

const initialState = {
  // Available apps
  isFetchingAvailableApps: false,
  isFetchingAvailableAppsFrom: 0,
  availableAppsTotalResults: 0,
  availableAppsLoaded: 0,
  availableApps: [],

  // Installed apps
  isFetchingInstalledApps: false,
  isFetchingInstalledAppsFrom: 0,
  installedAppsTotalResults: 0,
  installedAppsLoaded: 0,
  installedApps: [],

  // Installation status
  isInstallingApp: false,
  isUninstallingApp: false,
  installationError: null,
  
  // Featured apps
  isFetchingFeaturedApps: false,
  isFetchingFeaturedAppsFrom: 0,
  featuredAppsTotalResults: 0,
  featuredAppsLoaded: 0,
  featuredApps: [],

  // Categories
  isFetchingCategories: false,
  categories: [],

  // Category apps
  isFetchingCategoryApps: false,
  isFetchingCategoryAppsFrom: 0,
  categoryAppsTotalResults: 0,
  categoryAppsLoaded: 0,
  categoryApps: [],
  selectedCategory: null,

  // App status
  isFetchingAppStatus: false,
  appStatuses: {},

  error: null,
};

export default function appstore(state = initialState, action) {
  switch (action.type) {
    case appstoreConstants.APPSTORE_CHANGE_VALUE:
      return { ...state, error: '', [action.name]: action.value };

    // Available apps
    case appstoreConstants.GET_AVAILABLE_APPS_STARTED:
      return { ...state, isFetchingAvailableApps: true, isFetchingAvailableAppsFrom: action.from || 0 };
    case appstoreConstants.GET_AVAILABLE_APPS_FAILURE:
      return { ...state, isFetchingAvailableApps: false, availableApps: [], error: action.message || '' };
    case appstoreConstants.GET_AVAILABLE_APPS_SUCCESS:
      return {
        ...state,
        isFetchingAvailableApps: false,
        availableApps: action.from > 0 ? [...state.availableApps, ...action.apps] : action.apps,
        availableAppsLoaded: action.from > 0 ? state.availableApps?.length + action.apps?.length : action.apps?.length,
        availableAppsTotalResults: action.totalResults,
      };

    // Installed apps
    case appstoreConstants.GET_INSTALLED_APPS_STARTED:
      return { ...state, isFetchingInstalledApps: true, isFetchingInstalledAppsFrom: action.from || 0 };
    case appstoreConstants.GET_INSTALLED_APPS_FAILURE:
      return { ...state, isFetchingInstalledApps: false, installedApps: [], error: action.message || '' };
    case appstoreConstants.GET_INSTALLED_APPS_SUCCESS:
      return {
        ...state,
        isFetchingInstalledApps: false,
        installedApps: action.from > 0 ? [...state.installedApps, ...action.apps] : action.apps,
        installedAppsLoaded: action.from > 0 ? state.installedApps?.length + action.apps?.length : action.apps?.length,
        installedAppsTotalResults: action.totalResults,
      };

    // Install app
    case appstoreConstants.INSTALL_APP_STARTED:
      return { ...state, isInstallingApp: true, installationError: null };
    case appstoreConstants.INSTALL_APP_FAILURE:
      return { ...state, isInstallingApp: false, installationError: action.message || 'Installation failed' };
    case appstoreConstants.INSTALL_APP_SUCCESS:
      return {
        ...state,
        isInstallingApp: false,
        installationError: null,
        // Update app status
        appStatuses: {
          ...state.appStatuses,
          [action.appId]: { installed: true, installDate: new Date() }
        }
      };

    // Uninstall app
    case appstoreConstants.UNINSTALL_APP_STARTED:
      return { ...state, isUninstallingApp: true, installationError: null };
    case appstoreConstants.UNINSTALL_APP_FAILURE:
      return { ...state, isUninstallingApp: false, installationError: action.message || 'Uninstallation failed' };
    case appstoreConstants.UNINSTALL_APP_SUCCESS:
      return {
        ...state,
        isUninstallingApp: false,
        installationError: null,
        // Update app status
        appStatuses: {
          ...state.appStatuses,
          [action.appId]: { installed: false, uninstallDate: new Date() }
        },
        // Remove from installed apps if it exists
        installedApps: state.installedApps.filter(app => app.id !== action.appId)
      };

    // Featured apps
    case appstoreConstants.GET_FEATURED_APPS_STARTED:
      return { ...state, isFetchingFeaturedApps: true, isFetchingFeaturedAppsFrom: action.from || 0 };
    case appstoreConstants.GET_FEATURED_APPS_FAILURE:
      return { ...state, isFetchingFeaturedApps: false, featuredApps: [], error: action.message || '' };
    case appstoreConstants.GET_FEATURED_APPS_SUCCESS:
      return {
        ...state,
        isFetchingFeaturedApps: false,
        featuredApps: action.from > 0 ? [...state.featuredApps, ...action.apps] : action.apps,
        featuredAppsLoaded: action.from > 0 ? state.featuredApps?.length + action.apps?.length : action.apps?.length,
        featuredAppsTotalResults: action.totalResults,
      };

    // Categories
    case appstoreConstants.GET_CATEGORIES_STARTED:
      return { ...state, isFetchingCategories: true };
    case appstoreConstants.GET_CATEGORIES_FAILURE:
      return { ...state, isFetchingCategories: false, categories: [], error: action.message || '' };
    case appstoreConstants.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        isFetchingCategories: false,
        categories: action.categories || [],
      };

    // Category apps
    case appstoreConstants.GET_CATEGORY_APPS_STARTED:
      return { ...state, isFetchingCategoryApps: true, isFetchingCategoryAppsFrom: action.from || 0 };
    case appstoreConstants.GET_CATEGORY_APPS_FAILURE:
      return { ...state, isFetchingCategoryApps: false, categoryApps: [], error: action.message || '' };
    case appstoreConstants.GET_CATEGORY_APPS_SUCCESS:
      return {
        ...state,
        isFetchingCategoryApps: false,
        categoryApps: action.from > 0 ? [...state.categoryApps, ...action.apps] : action.apps,
        categoryAppsLoaded: action.from > 0 ? state.categoryApps?.length + action.apps?.length : action.apps?.length,
        categoryAppsTotalResults: action.totalResults,
      };

    // App status
    case appstoreConstants.GET_APP_STATUS_STARTED:
      return { ...state, isFetchingAppStatus: true };
    case appstoreConstants.GET_APP_STATUS_FAILURE:
      return { ...state, isFetchingAppStatus: false, error: action.message || '' };
    case appstoreConstants.GET_APP_STATUS_SUCCESS:
      return {
        ...state,
        isFetchingAppStatus: false,
        appStatuses: {
          ...state.appStatuses,
          [action.appId]: action.status
        }
      };

    default:
      return state;
  }
}